<template>
  <body class="ui_index modal-open">
  <div class="overlay"> </div>
    <div class="modal_fixed">
      <div class="new_achievement_box modal_cont" id="wheel_prize_modal">
        <img :src="closeIconSrc" class="btn_close" @click="goTOGetStarted">
        <h1>{{ getTranslations.visitor_free_trial_modals_yeah }}<br> {{ getTranslations.visitor_free_trial_modals_you_won }}</h1>
        <img src="/static/images/achievements/prize-spin.svg" class="prize_spin_img">
        <button type="" class="claim_prize" @click="goToRegistration">
          {{ getTranslations.visitor_free_trial_modals_claim_prize }}
        </button>
      </div>
  </div>
  </body>

</template>

<script>
// achievements_modal_wheel_prize.html
import { mapGetters, mapState, mapMutations } from 'vuex';
import SkinMixin from '@/common/mixins/skin';

export default {
  name: 'Winner',
  mixins: [SkinMixin],
  computed: {
    closeIconSrc() {
      return this.$_skinImage({ fileName: 'store/icon-close-back-popup.svg', skins: [100] });
    },
    ...mapState('common', [
      'freeTrialRedirectionUrl',
      'freeTrialPoints',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapGetters('common', [
      'getRefUrl',
      'getClickId',
      'getCampaignId',
      'getPublisherId',
    ]),
  },
  methods: {
    ...mapMutations('game', [
      'storeRegistrationPoints',
    ]),
    ...mapMutations('common', [
      'setFreeTrialUserPrice',
    ]),
    saveFreePoints() {
      return 0;
    },
    goTOGetStarted() {
      this.$router.push('/');
    },
    goToRegistration() {
      if (this.getRefUrl === undefined && this.getClickId === undefined && this.publisherId === undefined && this.campaignId === undefined) this.$router.push(`${this.freeTrialRedirectionUrl}?totalPoints=${this.saveFreePoints()}`);
      else this.$router.push(`${this.freeTrialRedirectionUrl}?refUrl=${this.getRefUrl || ''}&clickId=${this.getClickId || ''}&publisherId=${this.getPublisherId || ''}&campaignId=${this.campaignId || ''}&totalPoints=${this.saveFreePoints()}`);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/freeTrial/modals/Winner.vue